import { render, staticRenderFns } from "./createActivity.vue?vue&type=template&id=5c272d14&scoped=true&"
import script from "./createActivity.vue?vue&type=script&lang=js&"
export * from "./createActivity.vue?vue&type=script&lang=js&"
import style0 from "./createActivity.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./createActivity.vue?vue&type=style&index=1&id=5c272d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c272d14",
  null
  
)

component.options.__file = "createActivity.vue"
export default component.exports